module.exports = __webpack_public_path__ + "img/image25.4e7fa92d.png";